"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enums = void 0;
var ClassStepType;
(function (ClassStepType) {
    ClassStepType["BEHAVIOR"] = "BEHAVIOR";
    ClassStepType["DIVERSITY_FORM"] = "DIVERSITY_FORM";
    ClassStepType["TECHNICAL_TEST"] = "TECHNICAL_TEST";
})(ClassStepType || (ClassStepType = {}));
var ClassStructure;
(function (ClassStructure) {
    ClassStructure["WORKSHOP"] = "WORKSHOP";
    ClassStructure["FOUR_WEEKS"] = "FOUR_WEEKS";
    ClassStructure["SIX_WEEKS"] = "SIX_WEEKS";
    ClassStructure["EIGHT_WEEKS"] = "EIGHT_WEEKS";
    ClassStructure["TWELVE_WEEKS"] = "TWELVE_WEEKS";
    ClassStructure["FOURTEEN_WEEKS"] = "FOURTEEN_WEEKS";
    ClassStructure["EIGHTEEN_WEEKS"] = "EIGHTEEN_WEEKS";
})(ClassStructure || (ClassStructure = {}));
var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["ACTIVE"] = "ACTIVE";
    Status["FINISHED"] = "FINISHED";
    Status["DISABLED"] = "DISABLED";
})(Status || (Status = {}));
exports.enums = {
    status: Status,
    classStructure: ClassStructure,
    classStepType: ClassStepType,
};
//# sourceMappingURL=Class.js.map